import { render, staticRenderFns } from "./PFLoanFormNew.vue?vue&type=template&id=43127722"
import script from "./PFLoanFormNew.vue?vue&type=script&lang=js"
export * from "./PFLoanFormNew.vue?vue&type=script&lang=js"
import style0 from "./PFLoanFormNew.vue?vue&type=style&index=0&id=43127722&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports